import { container } from 'inversify-props';
import { SearchService } from '../services/search.service'
import HttpClient from '../services/http-client';
import { BookingService } from '../services/booking.service';
import { SavedTripsService } from '@/app/services/saved-trips.service';
import { AffiliateConfigurationService } from '@/app/services/affiliate-configuration.service';
import { TimeService } from '../services/time.service';
import { TasksService } from '../services/tasks.service';
import {CreditService} from "@/app/services/credit.service";

export default function buildDependencyContainer (): void {
  container.bindTo<HttpClient>(HttpClient, 'IHttpClient');
  container.bindTo<SearchService>(SearchService, 'ISearchService');
  container.bindTo<BookingService>(BookingService, 'IBookingService');
  container.bindTo<SavedTripsService>(SavedTripsService, 'ISavedTripsService');
  container.bindTo<AffiliateConfigurationService>(AffiliateConfigurationService, 'IAffiliateConfigurationService');
  container.bindTo<TimeService>(TimeService, 'ITimeService');
  container.bindTo<TasksService>(TasksService, 'ITasksService');
  container.bindTo<CreditService>(CreditService, 'ICreditService');
}
